export function triggerBlobDownload(blob: Blob, filename: string): void {
  const link = document.createElement('a')
  const objectUrl = window.URL.createObjectURL(blob)
  link.href = objectUrl
  link.download = filename
  link.click()
  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 100)
}
